var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{attrs:{"outlined":"","color":"black"}},[_c('div',{staticClass:"text-h6 text-center"},[_vm._v("Coming Soon")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }